import { Box, TextField, Typography } from '@mui/material';
import { Component, createRef } from 'react';
import AppManager from '../../commun/AppManager';
import { Spinner } from '../../commun/component/Spinner';
import { post } from '../../commun/HTTP';
import Result from '../../commun/Result';
import Toast from '../../commun/toast/Toast';
import Vendor from '../../object/profile/Vendor';
import { getErrorMessage } from '../../utils/Error';
import MpModal, { IBaseModalProps } from '../extends/MpModal';

export interface IVendorModalProps extends IBaseModalProps {
    vendor: Vendor | null;
    baseName?: string;
    onCreate?: (vendor: Vendor) => void;
}

export interface IVendorModalState {
    name: string;
    loading: boolean;
    error: string;
}

export default class VendorModal extends Component<IVendorModalProps, IVendorModalState> {
    inputRef: React.RefObject<HTMLInputElement>;

    constructor(props: IVendorModalProps) {
        super(props);

        this.state = this.initState();
        this.inputRef = createRef();
    }

    initState() {
        const p: IVendorModalState = {
            name: this.props.vendor?.name.get() ?? this.props.baseName ?? '',
            loading: false,
            error: '',
        };
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<IVendorModalProps>,
        prevState: Readonly<IVendorModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
        if (prevProps.open !== this.props.open && this.props.open) {
            setTimeout(() => {
                this.inputRef.current?.focus();
            });
        }
    }

    addPrestation() {
        const { loading, name } = this.state;
        const { vendor } = this.props;
        this.setState({
            loading: true,
            error: '',
        });
        let params: any;
        let url: string;
        if (vendor === null) {
            url = '/vendor/update';
            params = {
                name: name,
            };
        } else {
            url = '/vendor/update';
            params = {
                id: vendor.getAjoIdentifier(),
                name: name,
            };
        }
        if (vendor !== null) {
            params['id'] = vendor.getAjoIdentifier();
        }
        post(url, params).then((res: any) => {
            this.setState({
                loading: false,
            });
            if (Result.isSuccess(res)) {
                Result.applyResult(res, AppManager.updater(), true);

                const p = Vendor.build();
                Result.applyResult(res, p, true);
                this.props.onCreate?.(p);

                this.props.onClose();
                if (vendor === null) {
                    AppManager.addToast(new Toast('Le fournisseur a été ajouté avec succès.', 'success'));
                } else {
                    AppManager.addToast(new Toast('Le fournisseur a été modifié avec succès.', 'success'));
                }
            } else {
                this.setState({
                    error: getErrorMessage(Result.getErrorStr(res)),
                });
            }
        });
    }

    render() {
        const { open, vendor, onClose } = this.props;
        const { loading, name, error } = this.state;

        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.addPrestation();
                }}
                title={vendor === null ? 'Ajouter un fournisseur' : 'Modifier un fournisseur'}
                done={vendor === null ? 'Ajouter' : 'Modifier'}
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <Box className="flex flex-col !text-gray-600 gap-2">
                        <Typography className="!text-sm !font-semibold">NOM DU FOURNISSEUR</Typography>
                        <TextField
                            inputProps={{
                                ref: this.inputRef,
                            }}
                            fullWidth
                            value={name}
                            onChange={(e) => {
                                this.setState({ name: (e.target as any)?.value ?? '' });
                            }}
                            placeholder="Nom du fournisseur"
                            variant="outlined"
                        />

                        {error !== '' && (
                            <Typography
                                component={'p'}
                                className="!text-sm text-red-600 !mt-1 !mb-1 !font-medium text-center"
                            >
                                {error}
                            </Typography>
                        )}
                    </Box>
                )}
            </MpModal>
        );
    }
}
